import { removeBin, removeBinsOfDependency } from './removeBins.ts';

export { removeBin, removeBinsOfDependency };
